/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-script-url */
import React, { useState, useEffect } from "react";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Alert from "react-bootstrap/Alert";
import axios from "react-axios";

import { useUser } from "@dreamchimney/user-context";
import { addComment } from "~/api/getQuotes";
import { validateNonAuth, validateAuth } from "./CommentValidationRules";
import useCommentForm from "./useCommentForm";
import { LOCAL_STORE_JWT } from "~/utils/main";

import styled from "styled-components";

import "~/css/forms.less";

export const Wrapper = styled.section`
  margin: 6px 0 6px 0;
`;
export const TipsWrapper = styled.section`
  display: inline;
  float: right;
`;
export const SignInLinkWrapper = styled.section`
  text-decoration: underline;
  display: inline-block;
  margin-left: 7px;
  &:hover {
    cursor: pointer;
    text-decoration: none;
  }
`;

const CommentForm = ({ quote, onReply }) => {
  const { state: userState, dispatch } = useUser();
  const [loading, setLoading] = useState(true);
  const [loggedIn, setLoggedIn] = useState(true);

  const [showMessage, setShowMessage] = useState(false);

  const messageDisplayTime = 5000;
  const initialFormValues = { quoteComment: "" };

  useEffect(() => {
    setLoading(!userState.loaded);
    setLoggedIn(userState.loaded && userState.loggedin);
  }, [userState.loaded, userState.loggedin]);

  useEffect(() => {
    if (showMessage) {
      const timer = setTimeout(() => {
        setShowMessage(false);
      }, messageDisplayTime);
      return () => clearTimeout(timer);
    }
  }, [showMessage]);

  const validate = !loading && userState.loggedin ? validateAuth : validateNonAuth;
  // const isUserLoggedin = loading && userState.loggedin;

  const postComment = async () => {
    setLoading(true);

    const authorName = (inputs.author && inputs.author.trim()) || "";
    const author = userState.loggedin ? `${userState.user.dir}loggedin` : authorName;
    const quoteId = (quote && quote.id) || undefined;

    const jwt = localStorage.getItem(LOCAL_STORE_JWT) || false;
    const payload = {
      jwt,
      quote_id: quoteId,
      comment: inputs.quoteComment.trim(),
      user: author,
    };
    console.log("🚀 ~ file: CommentForm.js ~ line 73 ~ postComment ~ payload", payload);
    const response = await addComment(axios, payload);

    setLoading(false);

    if (response.status === 200) {
      setShowMessage(true);
      clearForm();
      onReply(response.data.comments);
    }
  };

  const { inputs, handleInputChange, handleSubmit, insertLinkTag, insertImageTag, clearForm, errors } = useCommentForm(
    initialFormValues,
    postComment,
    validate
  );

  const openSignin = () => {
    if (!userState.loggedin) {
      dispatch({ type: "signin_open" });
      return;
    }
  };

  return (
    <Wrapper>
      {loading && (
        <SkeletonTheme color="#fff" highlightColor="#f3f3f3">
          <Skeleton count={1} />
        </SkeletonTheme>
      )}

      {showMessage && <Alert variant="success">Thanks. Your comment was added.</Alert>}

      {
        <Form className="comment-form" noValidate onSubmit={(e) => handleSubmit(e)}>
          <h4>Add a comment:</h4>
          {!loggedIn && (
            <Form.Group as={Row} className={errors.author ? "error" : ""}>
              <Col md={6}>
                <div style={{ display: "flex" }}>
                  <span style={{ marginLeft: "0", marginTop: "10px", fontSize: "12px" }}>
                    <SignInLinkWrapper onClick={openSignin}>Login / Register to post a comment</SignInLinkWrapper>
                  </span>
                </div>
              </Col>
            </Form.Group>
          )}
          <Form.Group controlId="quoteComment" className={errors.quoteComment ? "error" : ""}>
            <Form.Control
              disabled={loading}
              name="quoteComment"
              onChange={handleInputChange}
              value={inputs.quoteComment || ""}
              as="textarea"
              rows="2"
              placeholder=""
              disabled={!loggedIn}
            />
          </Form.Group>

          <div className="comment-form-actions">
            {loggedIn && userState.loaded && (
              <div className="comment-html-help">
                HTML Help:{" "}
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    insertLinkTag();
                  }}
                >
                  Add link
                </a>
                &nbsp;&nbsp;
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    insertImageTag();
                  }}
                >
                  Add Image
                </a>
              </div>
            )}

            <Button disabled={loading} variant="light" type="submit" disabled={!loggedIn}>
              Reply
            </Button>
          </div>
        </Form>
      }
    </Wrapper>
  );
};

export default CommentForm;
